export default "<app-estado-cuenta [flagEdicion]=\"true\"></app-estado-cuenta>";